import React, { FC } from "react";
import { useParams, useNavigate } from "react-router-dom";

import { useGetStudentDetails } from "../../../hooks/students";

import StudentDetailsLayout from "../../layouts/Student";
import { PDFViewer } from "../../wrappers/PDFViewer";
import { Icons } from "../../../data/Assets";
import { SVGIcon } from "../../wrappers/SVGIcon";

import { DocumentType } from "./";
import SkeletonLoader from "../../reusables/SkeletonLoader";

interface DocumentFullPreviewProps {
  documentType: DocumentType;
  pdfPath: string | null;
  backRoute: string;
}

const DocumentFullPreview: FC<DocumentFullPreviewProps> = ({
  documentType,
  pdfPath,
  backRoute,
}) => {
  const { studentId: studentIdParam } = useParams();
  const navigate = useNavigate();
  const studentId = studentIdParam ? parseInt(studentIdParam) : 0;

  const { data: student } = useGetStudentDetails(studentId);

  const handleBack = () => {
    navigate(backRoute);
  };

  return (
    <StudentDetailsLayout
      goBackRoute={backRoute}
      operation="update"
      currentTab={documentType === "resume" ? "Resume" : "Cover-Letter"}
      title={student?.first_name + ' ' + student?.last_name}
      error={false}
      linkedStatus={{
        isDataAvailable: !!studentId,
        linked: !!student?.date_linked,
        linkedDate: student?.date_linked ?? null,
        unlinkedDate: student?.date_unlinked ?? null,
      }}
      isStudentAdded={!!student}
    >
      <div className="immersion__common_details__sub_info_container">
        <div className="immersion__common_details__sub_info_view" style={{ overflowY: "auto" }}>
          <div className="immersion__document_full_preview">
            <div className="immersion__document_full_preview__header">
              <button
                className="immersion__document_full_preview__back"
                onClick={handleBack}
              >
                <SVGIcon src={Icons.Arrow} color="dark_grey" hoverColor="dark_grey" rotation={90} />
                <span>
                  Back to{" "}
                  {documentType === "resume" ? "Resumes" : "Cover Letters"}
                </span>
              </button>
              {/* Buttons temporarily hidden
                            <div className="immersion__document_full_preview__actions">
                                <button className="immersion__btn immersion__btn_outline">
                                    <SVGIcon src={Icons.Download} color="primary" />
                                    <span>Download</span>
                                </button>
                                <button className="immersion__btn immersion__btn_primary">
                                    <span>Edit {documentType === 'resume' ? 'Resume' : 'Cover Letter'}</span>
                                </button>
                            </div>
                            */}
            </div>
            <div className="immersion__document_full_preview__content">
              {/* <object
                                data={pdfPath}
                                type="application/pdf"
                                className="immersion__document_full_preview__pdf"
                            >
                                <p>Unable to display PDF file. <a href={pdfPath} target="_blank" rel="noopener noreferrer">Download</a> instead.</p>
                            </object> */}
              <div className="immersion__document_full_preview__pdf">
                {pdfPath ? (
                  <PDFViewer signedUrl={pdfPath} scale={1} />
                ) : (
                  <SkeletonLoader type="image" />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </StudentDetailsLayout>
  );
};

export default DocumentFullPreview;
